import React from 'react';
import {Brand, PageHeaderTools, PageHeader, Button} from "@patternfly/react-core";

import {Language} from "../App";

type Props = {
    onChangeL10n: any,
    l10n: string
}

export const SignpostHeader: React.FC<Props> = ({onChangeL10n, l10n}) => {

    const logoProps = {
        href: process.env.PUBLIC_URL
    };

    return (
        <PageHeader
            logo={
                <React.Fragment>
                    <Brand className="brand"
                           src={process.env.PUBLIC_URL + '/logo.png'}
                           alt="Patternfly Logo" />
                </React.Fragment>
            }
            headerTools={
                <PageHeaderTools>
                    <Button variant="plain"
                            className="l10nButton"
                            aria-label="Action" onClick={onChangeL10n}>
                        <img alt="change language"
                             src={process.env.PUBLIC_URL + (l10n === Language.CZECH ? '/cz.svg' : '/uk.png')}
                             className="l10nImg"/>
                    </Button>
                </PageHeaderTools>
            }
            logoProps={logoProps}
        >
        </PageHeader>
    );
}

export default SignpostHeader;